<template>
    <aside aria-labelledby="booking-preview-heading">
        <BaseMockBookingForm>
            <template #content>
                <div class="p-4">
                    <h2
                        id="booking-preview-heading"
                        class="text-center text-sm font-bold text-slate-700"
                    >
                        Book a service
                    </h2>

                    <div class="mt-3 space-y-2.5">
                        <MockBookingFormService
                            :duration="15"
                            title="Free Discovery Call"
                            description="A short intro call to understand goals, fit, and next steps."
                        />
                        <MockBookingFormService
                            :duration="45"
                            title="1:1 Coaching Session"
                            description="Ongoing coaching with one consistent time slot each week."
                            isRecurring
                        />
                        <MockBookingFormService
                            :duration="60"
                            title="Growth Strategy Session"
                            description="A paid working session to map priorities, blockers, and recommendations."
                        />
                    </div>
                </div>
            </template>
        </BaseMockBookingForm>
    </aside>
</template>

<script setup lang="ts">
    import BaseMockBookingForm from '@/Shared/Component/BaseMockBookingForm.vue'
    import MockBookingFormService from '@/Shared/Component/MockBookingFormService.vue'
</script>
